import type { TopPlayer } from '@/modules/common/hooks/useTournaments';
import { TOURNAMENT_SS_WIDGETS } from './constants';

export enum TournamentMode {
  ACTIVE = 'active',
  FINISHED = 'finished',
  COMING_SOON = 'comingSoon',
}

export const getSSWidgetLink = (widgetId?: string) => {
  if (!widgetId) return '';
  return TOURNAMENT_SS_WIDGETS.replace('{}', widgetId);
};

enum TournamentStrategy {
  Bet = 'bet',
  Win = 'win',
  Rate = 'rate',
  Spin = 'spin',
  Points = 'points',
}

const mapTournamentPointsField: Record<TournamentStrategy, keyof TopPlayer> = {
  [TournamentStrategy.Bet]: 'bets',
  [TournamentStrategy.Win]: 'wins',
  [TournamentStrategy.Rate]: 'rate',
  [TournamentStrategy.Spin]: 'gamesTaken',
  [TournamentStrategy.Points]: 'points',
};

export const getPlayerTournamentPoints = (
  strategy: string,
  playerInfo: TopPlayer | undefined
): number => {
  const pointsField = mapTournamentPointsField[strategy as TournamentStrategy];

  return Number(playerInfo?.[pointsField]) || 0;
};
